import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import {
  VRow,
  VCol,
  VTextField,
  VTooltip,
  VCheckbox,
  VSelect,
  VCard,
} from "vuetify/lib/components";
import { Ripple, Intersect, Touch, Resize } from "vuetify/lib/directives";
import de from "vuetify/lib/locale/de";

Vue.use(Vuetify, {
  components: { VRow, VTooltip, VCol, VTextField, VCheckbox, VSelect, VCard },
  directives: { Ripple, Intersect, Touch, Resize },
});

export default new Vuetify({
  icons: {
    iconfont: "mdiSvg",
  },
  theme: {
    themes: {
      light: {
        primary: "#B22222",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#B22222", //original: #FF5252
        info: "#2196F3",
        success: "#148945", //'#4CAF50',
        warning: "#FFC107",
      },
    },
  },
  lang: {
    locales: { de },
    current: "de",
  },
});
